import { render } from "./EnNavbar.vue?vue&type=template&id=52e1b31e&scoped=true"
import script from "./EnNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./EnNavbar.vue?vue&type=script&setup=true&lang=js"

import "./EnNavbar.vue?vue&type=style&index=0&id=52e1b31e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e1b31e"],['__file',"Shared/components/navigation/EnNavbar/EnNavbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52e1b31e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52e1b31e', __exports__)) {
    api.reload('52e1b31e', __exports__)
  }
  
  module.hot.accept("./EnNavbar.vue?vue&type=template&id=52e1b31e&scoped=true", () => {
    api.rerender('52e1b31e', render)
  })

}


export default __exports__